export const Plus = () => (
  <svg width="1em" height="1em" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.5 5.625V10M10.5 10V14.375M10.5 10H6.125M10.5 10H14.875"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
)

export default Plus
